import api from '@/utils/api';

/**
 * Create a quote
 * @param {object} data - The data
 * @returns {Promise}
 */
const createQuote = (data) => api.post('/quote', data);

export default createQuote;
